import { api } from "@/lib/api/client";
import type {
  DocumentSummary,
  DocumentDetail,
  DocumentListResponse,
  DocumentListQuery,
} from "@pkhoffice/shared";

export async function fetchDocuments(
  q: Partial<DocumentListQuery> | Record<string, string | number | undefined>,
): Promise<DocumentListResponse> {
  const { data } = await api.get("/document/list", { params: q });
  return data.data ?? data;
}

export async function fetchDocumentsIncoming(
  q?: Record<string, string | number | undefined>,
): Promise<DocumentListResponse> {
  const { data } = await api.get("/document/incoming", { params: q });
  return data.data ?? data;
}

export async function fetchDocumentsOutgoing(
  q?: Record<string, string | number | undefined>,
): Promise<DocumentListResponse> {
  const { data } = await api.get("/document/outgoing", { params: q });
  return data.data ?? data;
}

export async function fetchDocumentsOrgTree(
  q?: Record<string, string | number | undefined>,
): Promise<DocumentListResponse> {
  const { data } = await api.get("/document/org-tree", { params: q });
  return data.data ?? data;
}

export async function fetchDocument(id: number): Promise<DocumentDetail> {
  const { data } = await api.get(`/document/${id}`);
  return data.data ?? data;
}

export async function searchDocuments(q: string): Promise<DocumentListResponse> {
  const { data } = await api.get("/document/search", { params: { q } });
  return data.data ?? data;
}

export async function createDocument(payload: Record<string, unknown>): Promise<DocumentDetail> {
  const { data } = await api.post("/document", payload);
  return data.data ?? data;
}

export async function updateDocument(
  id: number,
  payload: Record<string, unknown>,
): Promise<DocumentDetail> {
  const { data } = await api.put(`/document/${id}`, payload);
  return data.data ?? data;
}

export async function deleteDocument(id: number): Promise<void> {
  await api.delete(`/document/${id}`);
}

export async function uploadFile(
  file: File,
  documentId?: number,
): Promise<{ fileId: number; fileName: string; size: number; storagePath: string }> {
  const fd = new FormData();
  fd.append("file", file);
  if (documentId !== undefined) fd.append("documentId", String(documentId));
  const { data } = await api.post("/file/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.data ?? data;
}

export type { DocumentSummary };
